import ContextMenu from 'devextreme-react/context-menu';
import React from 'react';

export default function TableContextMenu (props) {
    const {setVisible,enableChangeState,handleRowClick,target,visible,rowSelected,enableEdit,handleOptionChange,caseStates,handleChangeStateCases} = props;


    function getCaseStates () {

        function items() {
            let array = [];
            if (caseStates != null && caseStates.length > 0 && enableChangeState) {
                caseStates.map((value,index) => {
                    if(value.stateId !==6 || !value.description.toLowerCase().includes("gestionado")){
                        array.push({id: value.stateId,text:value.description, items: value.subStates.map(sb=> {return {subStateId: sb.subStateId, text: sb.description, id: sb.parentStateId}})})
                    }                
                });
            }
            return array;
        };

        let  contextMenuItems = [
            { text: 'Editar',disabled:enableEdit},
            { text: 'Mudar estado',items:items(),visible:enableChangeState},
            { text: 'Marcar como não gerenciado',visible:enableChangeState}]

        return contextMenuItems;
    }

    function itemClick(e) {
        if (!e.itemData.items && e.itemData.text == "Editar") {
           handleRowClick(rowSelected);
        }else if(e.itemData.text == "Marcar como não gerenciado"){
            props.handleSetNotManaged(e.itemData.id);
            setVisible(false);
        }else if ( e.itemData.id != null && e.itemData.id > 0 ) {
            props.handleChangeStateCases(e.itemData.id, e.itemData.subStateId);
            setVisible(false);
        }
    };

    return ( <ContextMenu
        items={getCaseStates()}
        visible={visible}
        target={target}
        onOptionChanged={handleOptionChange}
        onItemClick={itemClick}
        />);
}

